import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import CookieConsent from "@/components/CookieConsent";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import { ScrollProgress } from "@/components/ScrollProgress";
import { AccessibilityWidget } from "@/components/accessibility/AccessibilityWidget";
import { useState, useEffect } from "react";


interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [a11yOpen, setA11yOpen] = useState(false);

  useEffect(() => {
    const handler = () => setA11yOpen(true);
    window.addEventListener('open-accessibility', handler);
    return () => window.removeEventListener('open-accessibility', handler);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="skip-link">
        Zum Inhalt springen
      </a>
      <ScrollProgress />
      <GoogleAnalytics />
      <Header />
      <main id="main-content" className="flex-1 pt-[72px] overflow-x-hidden">
        {children}
      </main>
      <Footer />
      <AccessibilityWidget isOpen={a11yOpen} onClose={() => setA11yOpen(false)} />
      <CookieConsent />
    </div>
  );
}

